<div class="splash" [ngStyle]="getSplashBackground()">
    <div class="container">
        <div [ngClass]="{ 'splash-cta--no-buttons': isNoButtons }" class="splash-cta">
            @if (block.data.heading) {
                <h1 [innerHtml]="block.data.heading" class="splash-cta__heading"></h1>
            }
            @if (block.data.text) {
                <div [innerHtml]="block.data.text" class="splash-cta__text"></div>
            }
            <div class="splash-cta__buttons">
                <!-- Standard link -->
                @if (showStdLink) {
                    <ng-container
                        *ngTemplateOutlet="
                            ctaButton;
                            context: {
                                text: block.data.linkText,
                                link: block.data.link,
                                external: block.data.externalLink,
                                aria: block.data.linkAriaLabel,
                            }
                        "></ng-container>
                }
                <!-- SSO link -->
                @if (showSsoLink) {
                    <ng-container
                        *ngTemplateOutlet="
                            ctaButtonSso;
                            context: {
                                text: block.data.linkText,
                                sso: block.data.ssoLink,
                                aria: block.data.linkAriaLabel,
                            }
                        "></ng-container>
                }
                <!-- Optional second links -->
                @if (showStdLink2) {
                    <ng-container
                        *ngTemplateOutlet="
                            ctaButton;
                            context: {
                                text: block.data.linkText2,
                                link: block.data.link2,
                                external: block.data.externalLink2,
                                aria: block.data.linkAriaLabel2,
                            }
                        "></ng-container>
                }
                @if (showSsoLink2) {
                    <ng-container
                        *ngTemplateOutlet="
                            ctaButtonSso;
                            context: {
                                text: block.data.linkText2,
                                sso: block.data.ssoLink2,
                                aria: block.data.linkAriaLabel2,
                            }
                        "></ng-container>
                }
            </div>
        </div>
    </div>
</div>

<!-- Reusable CTA button template -->
<ng-template #ctaButton let-text="text" let-link="link" let-external="external" let-aria="aria">
    @if (!external) {
        <!-- Not external so we're safe to use routerLink -->
        <a
            [innerText]="text"
            [routerLink]="link"
            [target]="external ? '_blank' : '_self'"
            [attr.aria-label]="aria ? aria : ''"
            class="btn btn-primary align-self-start mb-0"></a>
    } @else {
        <!-- External so we're using href -->
        <a
            [innerText]="text"
            [href]="link"
            [target]="external ? '_blank' : '_self'"
            [attr.aria-label]="aria ? aria : ''"
            class="btn btn-primary align-self-start mb-0"></a>
    }
</ng-template>

<ng-template #ctaButtonSso let-text="text" let-sso="sso" let-aria="aria">
    <a
        [innerText]="text"
        href="javascript:void(0);"
        (click)="initiateSSO(sso)"
        [attr.aria-label]="aria ? aria : ''"
        class="btn btn-primary align-self-start mb-0"></a>
</ng-template>

<!--TODO: Add Wistia video as background option -->
